export default __webpack_public_path__ + "static/media/119.0f201273.jpeg";